import { render, staticRenderFns } from "./swipeDialog.vue?vue&type=template&id=48098db4&scoped=true"
import script from "./swipeDialog.vue?vue&type=script&lang=js"
export * from "./swipeDialog.vue?vue&type=script&lang=js"
import style0 from "./swipeDialog.vue?vue&type=style&index=0&id=48098db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48098db4",
  null
  
)

export default component.exports